// src/components/AdminRoute.tsx
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

const ADMIN_ROLES = ["superadmin", "admin"];

function getRoleFromToken(): string | null {
  const stored = localStorage.getItem("user_role");
  if (stored) return stored;

  // Fall back to decoding the JWT payload if the role wasn't stored.
  const token =
    localStorage.getItem("access_token") ?? sessionStorage.getItem("access_token");
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload?.role ?? null;
  } catch {
    return null;
  }
}

type Props = { children: ReactNode };

export default function AdminRoute({ children }: Props) {
  const location = useLocation();
  const role = getRoleFromToken();

  if (!role || !ADMIN_ROLES.includes(role)) {
    return (
      <Navigate to="/super-admin" replace state={{ from: location.pathname }} />
    );
  }

  return <>{children}</>;
}
